export default {
  login: "เข้าสู่ระบบ",
  account: "บัญชีผู้ใช้",
  register: "ลงทะเบียน",
  loginTime: "เวลาล็อกอิน",
  long: "นาน",
  new: "ใหม่",
  content: "เนื้อหา",
  companyName: "โรงงานสาขาตงเฉิง บริษัท ซินเฟิง สแตนเลส โปรดักส์ จำกัด",
  email: "อีเมล",
  phone: "เบอร์โทรศัพท์",
  personalInformation: "ข้อมูลส่วนตัว",
  personalSettings: "การตั้งค่าส่วนตัว",
  password: "รหัสผ่าน",
  logout: "ออกจากระบบ",
  personal_center: "ศูนย์ส่วนตัว",
  workshop: "แผนกผลิต",
  personnel: "บุคลากร",
  problem: "ปัญหา",
  summary: "สรุป",
  question: {
    problemReport: "รายงานปัญหา 6S",
    create: "สร้างปัญหาใหม่",
    auditDocuments: "ตรวจสอบเอกสาร",
    untreated: "ยังไม่ดำเนินการ",
    processing: "กำลังดำเนินการ",
    currentMonth: "ปัญหาเฉพาะเดือนนี้",
    recently: "ปัญหาที่เกิดขึ้นล่าสุด",
    data: "กราฟข้อมูลประจำเดือน",
    specific: "รายละเอียดปัญหา",
    feedbackContent: "เนื้อหาข้อเสนอแนะ",
    issuesWorkshop: "เดือนนี้ไม่มีปัญหาในแผนก",
    viewingIssues: "ดูปัญหา",
    deductionSituation: "สถานการณ์การหักคะแนน",
    specificLocation: "ตำแหน่งที่แน่นอน",
    discoveryTime: "เวลาพบปัญหา",
    requestRectificationTime: "เวลาที่ขอแก้ไข",
    actualRectificationTime: "เวลาที่แก้ไขจริง",
    processingStatusOfEachWorkshop: "สถานะการดำเนินการของแต่ละแผนก",
    workshopFeedback: "ข้อเสนอแนะจากแผนก",
    frequency: "จำนวนครั้งของปัญหา"
  },
  attendance: {
    value: "การเข้างาน",
    dongchengNoProduction: "โรงงานตงเฉิง - ไม่ผลิต",
    dongchengProduction: "โรงงานตงเฉิง - ผลิต",
    bakingNoProduction: "แผนกเบเกอรี่ - ไม่ผลิต",
    bakingProduction: "แผนกเบเกอรี่ - ผลิต",
    personal: "การเข้างานส่วนบุคคล",
    number: "รหัสการเข้างาน",
    workCard: "บันทึกเข้างาน",
    offDutyCard: "บันทึกออกงาน",
    data: "ข้อมูลปรับเทียบผลผลิต",
    team: "ทีม",
    wages: "ค่าจ้าง",
    punching: "บันทึกการตอกบัตร",
    punchingNum: "จำนวนครั้งการตอกบัตร",
    overtimeHours: "ชั่วโมงทำงานล่วงเวลา",
    worktime: "ชั่วโมงทำงาน",
    totalWork: "ชั่วโมงทำงานรวม",
    total: "สถิติ",
    recosting: "คำนวณใหม่",
    worklate: "นาทีมาสาย",
    extra: "ชั่วโมงทำงานนอกสถานที่",
    allDay: "จำนวนวันทั้งหมด",
    allOvertime: "ชั่วโมงล่วงเวลารวม",
    allWorktime: "ชั่วโมงทำงานรวมทั้งหมด",
    normalDay: "จำนวนวันทำงานปกติ",
    normalOvertime: "ชั่วโมงล่วงเวลาปกติ",
    saturdayDay: "จำนวนวันทำงานสุดสัปดาห์",
    saturdayOvertime: "ชั่วโมงล่วงเวลาวันหยุด",
    holiday: "จำนวนวันทำงานวันหยุด",
    holidayOvertime: "ชั่วโมงทำงานวันหยุด",
    absentee: "จำนวนการขาดงาน",
    clockIn: "ตอกบัตรเข้า",
    adjust: "ปรับ",
    leave: "ลางาน",
    supplementaryWorkingHours: "เพิ่มชั่วโมงทำงาน",
    cardReplacement: "ขอบัตรแทน",
    clockInDetails: "รายละเอียดการตอกบัตร",
    cardReplacementApplication: "คำขอบัตรแทน",
    workHourApplication: "คำขอชั่วโมงทำงาน",
    checkInAdjustment: "ปรับเวลาตอกบัตร",
    leaveVerification: "ตรวจสอบการลา",
    check: "ตรวจสอบ"
  },
  mealExpenses: "ค่าอาหาร",
  project: "โครงการ",
  total: "รวมทั้งหมด",
  totalScore: "คะแนนรวม",
  averageScore: "คะแนนเฉลี่ย",
  totalDeductionPoints: "คะแนนหักรวม",
  qualified: "ผ่านเกณฑ์",
  unqualified: "ไม่ผ่านเกณฑ์",
  remarks: "หมายเหตุ",
  class: "ประเภท",
  index: "ดัชนี",
  all: "ทั้งหมด",
  creationTime: "เวลาสร้าง",
  data: "ข้อมูลต้นฉบับ",
  view: "ดู",
  add: "เพิ่ม",
  edit: "แก้ไข",
  query: "ค้นหา",
  update: "อัปเดต",
  save: "บันทึก",
  delete: "ลบ",
  batchDelete: "ลบหลายรายการ",
  bind: "ผูก",
  cancel: "ยกเลิก",
  confirmed: "ยืนยัน",
  success: "สำเร็จ",
  cannotBeEmpty: "ห้ามเว้นว่าง",
  submit: "ส่ง",
  clear: "ล้างข้อมูล",
  group: "กลุ่ม",
  reset: "รีเซ็ต",
  details: "รายละเอียด",
  export: "ส่งออก",
  noData: "ไม่มีข้อมูล",
  import: "นำเข้า",
  pass: "ผ่าน",
  fail: "ไม่ผ่าน",
  score: "คะแนน",
  upload: "อัปโหลด",
  img: "รูปภาพ",
  user: "ผู้ใช้",
  moniker: "ชื่อ",
  main: "หน้าหลัก",
  name: "ชื่อ",
  strategy: "กลยุทธ์",
  select: "เลือก",
  exit: "ออก",
  workType: "ประเภทงาน",
  depart: "แผนก",
  positions: "ตำแหน่ง",
  morning: "เช้า",
  afternoon: "บ่าย",
  date: "วันที่",
  wholeYears: "ตลอดทั้งปี",
  years: "ปี",
  months: "เดือน",
  days: "วัน",
  daysNum: "จำนวนวัน",
  sameDay: "วันเดียวกัน",
  holidays: "วันหยุด",
  dateInterval: "ช่วงเวลา",
  approval: "อนุมัติ",
  category: "หมวดหมู่",
  operation: "การดำเนินการ",
  opinion: "ความคิดเห็น",
  uploader: "ผู้อัปโหลด",
  english: "ภาษาอังกฤษ",
  chinese: "ภาษาจีน",
  thai: "ภาษาไทย",
  type: "ประเภท",
  sequence: "ลำดับ",
  menu: {
    viewDetails: "ดูรายละเอียด",
    checkMonthlyCardShortages: "ตรวจสอบการขาดบัตรประจำเดือน",
    checkTheDailyCardShortage: "ตรวจสอบการขาดบัตรประจำวัน",
    workInquiriesForConsecutiveDays: "ตรวจสอบการทำงานติดต่อกัน 14 วัน",
    viewTheListOfMissingCards: "ดูรายการขาดบัตร",
    continuousWorkingHours: "ชั่วโมงทำงานต่อเนื่อง",
    personnelMaintenanceStatistics: "สถิติการบำรุงรักษาบุคลากร",
    equipmentMaintenanceStatistics: "สถิติการบำรุงรักษาเครื่องจักร",
    workshopMaintenanceStatistics: "สถิติการบำรุงรักษาแผนก",
    importAttendance: "นำเข้าข้อมูลการเข้างาน",
    lateQuery: "บันทึกการมาสาย",
    absentee: "ตรวจสอบการลา",
    lateSchedule: "ตารางเวลามาสาย",
    annualAttendanceStatistics: "สถิติการเข้างานรายปี",
  },
  error: {
    pleaseEnterDate: "กรุณากรอกวันที่",
    mes: "เกิดข้อผิดพลาด",
    param: "พารามิเตอร์ไม่ถูกต้อง"
  },
  mes: {
    connectionSuccessful: "เชื่อมต่อสำเร็จ",
    loading: "กำลังโหลด...",
    disconnect: "ตัดการเชื่อมต่อ",
    reconnecting: "กำลังเชื่อมต่อใหม่...",
    rconnectionFailed: "เชื่อมต่อใหม่ล้มเหลว",
    pleaseEnterTheTimeCorrectly: "กรุณากรอกเวลาให้ถูกต้อง",
    pleaseEnterFeedbackContent: "กรุณากรอกเนื้อหาข้อเสนอแนะ",
    pleaseSelect: "กรุณาเลือก",
    pleaseEnterYourPhoneNumber: "กรุณากรอกเบอร์โทรศัพท์",
    chooseaMachine: "เลือกเครื่องจักร",
    selectExamPaper: "เลือกแบบทดสอบ",
    selectParticipants: "เลือกผู้เข้าร่วม",
    pleaseUploadPictures: "กรุณาอัปโหลดรูปภาพ",
    pleaseSelectAFollowUpPerson: "กรุณาเลือกผู้ติดตาม",
    pleaseEnterAtLeastWords: "กรุณากรอกอย่างน้อย 20 คำ",
    pleaseEnterTheNameOfTheExamPaper: "กรุณากรอกชื่อแบบทดสอบ",
    pleaseEnterTheSuggestedDuration: "กรุณากรอกระยะเวลาที่แนะนำ",
    pleaseEnterAHeading: "กรุณากรอกหัวข้อ",
    pleaseEnterInOrder: "กรุณากรอกตามลำดับ"
  },
  finish: "เสร็จสิ้น",
  create: "รอรับงาน",
  process: "กำลังดำเนินการ",
  faultReportingTime: "เวลารายงานปัญหา",
  reporter: "ผู้รายงาน",
  faultContent: "รายละเอียดปัญหา",
  singlePersonReception: "ผู้รับงาน",
  state: "สถานะ",
  jan: "มกราคม",
  feb: "กุมภาพันธ์",
  mar: "มีนาคม",
  apr: "เมษายน",
  may: "พฤษภาคม",
  jun: "มิถุนายน",
  jul: "กรกฎาคม",
  aug: "สิงหาคม",
  sep: "กันยายน",
  oct: "ตุลาคม",
  nov: "พฤศจิกายน",
  dec: "ธันวาคม",
  number: "หมายเลข",
  device: {
    name: "อุปกรณ์",
    repairQuantity: "จำนวนการซ่อม"
  },
  accessory: "อุปกรณ์เสริม",
  stamping: "ปั๊มขึ้นรูป",
  braze: "บัดกรี",
  freeze: "เชื่อม",
  burnishing: "ขัดเงา",
  sanding: "ขัดทราย",
  accessoriesPolishing: "ขัดอุปกรณ์เสริม",
  package: "บรรจุภัณฑ์",
  mold: "แม่พิมพ์",
  engineering: "ฝ่ายวิศวกรรม",
  warehouse: "คลังสินค้า",
  production: "ฝ่ายผลิต",
  technology: "ฝ่ายเทคนิค",
  inspection: "ฝ่ายตรวจสอบคุณภาพ",
  equipment: "ฝ่ายเครื่องจักร",
  finance: "ฝ่ายการเงิน",
  manage: "ฝ่ายบริหาร",
  office: "สำนักงาน",
  grade: "คะแนน",
  inProgress: "กำลังติดตาม",
  followUpCompleted: "ติดตามเสร็จสิ้น",
  verificationCompleted: "ตรวจสอบเสร็จสิ้น",
  verificationFailed: "ตรวจสอบไม่ผ่าน",
  option: "ตัวเลือก",
  fillInTheBlank: "เติมคำในช่องว่าง",
  examine: {
    view: "การประเมิน",
    content: "เนื้อหาการประเมิน",
    standard: "มาตรฐานการประเมิน",
    poor: "แย่ (ต่ำกว่า 60)",
    secondary: "ปานกลาง (61–75)",
    good: "ดี (76–90)",
    outstanding: "ยอดเยี่ยม (91–100)",
    assessor: "ผู้ประเมิน",
    evaluatedPerson: "ผู้ถูกประเมิน",
    assessmentMonth: "เดือนที่ประเมิน",
    contentAndDefinition: "เนื้อหาและคำจำกัดความของตัวชี้วัด",
    manageGrade: "คะแนนการบริหาร",
    metrics: "ตัวชี้วัดย่อย",
    weight: "ค่าน้ำหนัก",
    superMax: "เกินคะแนนสูงสุดของรายการ",
    total: {
      depart: "สถิติแผนก",
      workshop: "สถิติแผนกผลิต"
    },
    depart: {
      personInChargeRating: "คะแนนหัวหน้าแผนก",
      ratingForm: "แบบฟอร์มการประเมินประจำเดือนแผนกตงเฉิง",
      evaluatedDepartment: "แผนกที่ถูกประเมิน",
      rating: "คะแนนแผนก",
      instructions:
        "คำอธิบาย: แบบฟอร์มนี้ใช้สำหรับการประเมินประสิทธิภาพของพนักงานในแผนก ตัวชี้วัดและค่าน้ำหนักถูกกำหนดไว้อย่างชัดเจน สามารถปรับเปลี่ยนได้ตามลักษณะงานหรือหน้าที่เฉพาะของแต่ละตำแหน่ง"
    },
    device: {
      content: "เนื้อหาการบำรุงรักษา",
      ratingForm: "แบบฟอร์มประเมินการบำรุงรักษาเครื่องจักรแผนกตงเฉิง",
      instructions: "หมายเหตุ: หักคะแนนตามระดับความรุนแรงของปัญหา"
    },
    logistics: {
      ratingForm: "แบบฟอร์มประเมินแผนกสนับสนุนการผลิตแบบลีน โรงงานตงเฉิง",
      instructions: `คำอธิบาย:
1. การให้คะแนนต้องยุติธรรม ไม่ได้รับผลกระทบจากความขัดแย้งส่วนตัว
2. หลังให้คะแนน โปรดส่งแบบฟอร์มนี้ไปยังแผนกบริหาร
3. มาตรฐานการให้คะแนนของฝ่ายวิศวกรรม แม่พิมพ์ และคลังสินค้า: ฝ่ายโรงงาน 40% แผนกผลิต 60% ผลสุดท้ายคือค่าเฉลี่ยของคะแนนทั้งหมด`
    },
    satisfaction: {
      ratingDepartment: "แผนกที่ให้คะแนน",
      ratingWorkshop: "แผนกผลิตที่ให้คะแนน",
      departRatingForm: "แบบฟอร์มประเมินความพึงพอใจแผนก",
      workshopRatingForm: "แบบฟอร์มประเมินความพึงพอใจแผนกผลิต",
      instructions: "หมายเหตุ: หักคะแนนตามความรุนแรงของปัญหา"
    },
    warehouse: {
      ingredients:
        "หมายเหตุ: โปรดให้คะแนนอย่างเป็นธรรมต่อพนักงานคลังสินค้าที่มีปฏิสัมพันธ์ทางงานเท่านั้น"
    },
    workshop: {
      ratingForm: "แบบฟอร์มประเมินประสิทธิภาพประจำเดือนแผนกตงเฉิง",
      ratingWorkshop: "แผนกที่ประเมิน",
      explain: "คำอธิบายการเพิ่ม/หักคะแนน",
      instructions:
        "หัวหน้าแต่ละคนต้องส่งข้อมูลให้แผนกบริหารก่อนวันที่ 5 ของทุกเดือน",
      assessment_dimension: "มิติการประเมิน",
      target_name: "ชื่อตัวชี้วัด",
      source: "แหล่งข้อมูล",
      assessment_score: "คะแนนประเมิน"
    }
  },
  training: {
    lecturer: "วิทยากร",
    name: "ชื่อการอบรม",
    numberOfRetakes: "จำนวนครั้งสอบซ้ำ",
    startSigningIn: "เริ่มลงชื่อ",
    endOfTraining: "สิ้นสุดการอบรม",
    notSignedIn: "ยังไม่ลงชื่อ",
    signedIn: "ลงชื่อแล้ว",
    difficulty: "ระดับความยาก",
    rating: "การให้คะแนน",
    exam: "การสอบ",
    paperEditor: "ตัวแก้ไขแบบทดสอบ",
    title: "หัวข้อ",
    type: "ประเภทคำถาม",
    paper: "แบบทดสอบ",
    answer: "คำตอบ",
    parse: "การอธิบาย",
    actualNumberOfParticipants: "จำนวนผู้เข้าร่วมจริง",
    realNumber: "จำนวนผู้เข้าร่วมที่คาดไว้",
    attendanceRate: "อัตราการเข้าร่วม",
    machine: "เครื่องจักร",
    date: "วันที่อบรม",
    plan: "แผน",
    checkInQRCode: "QR Code ลงชื่อเข้าอบรม",
    dragMe: "ลากฉัน",
    remarks:
      "(หมายเหตุ: ใช้ภายใน แบบทดสอบประกอบด้วยคำถามแบบเลือกเดี่ยวและตัดสินใจ รวมทั้งหมด 100 คะแนน ผ่านที่ 90 คะแนน)",
    compilerAdds: "เพิ่มโดยเครื่องมือแก้ไข",
    downloadTheExamPaper: "ดาวน์โหลดแบบทดสอบ",
    questionnaireEditor: "ตัวแก้ไขแบบสอบถาม",
    pasteQuestionnaireText: "วางข้อความแบบสอบถาม",
    question: "คำถาม",
    questionType: "ประเภทคำถาม",
    correctAnswer: "คำตอบที่ถูกต้อง",
    questionScore: "คะแนนคำถาม",
    fillInTheTestPaperInformation: "กรอกข้อมูลแบบทดสอบ",
    duration: "ระยะเวลา",
    multiple_choice: "คำถามเลือกเดียว",
    single_choice: "คำถามหลายตัวเลือก",
    true_false: "คำถามถูก/ผิด",
    pasteFill: "วางเพื่อเติม",
    richTextEditing: "แก้ไขข้อความแบบสมบูรณ์",
    suggestedDuration: "ระยะเวลาที่แนะนำ (นาที)",
    heading: "หัวข้อ"
  },
  verification: {
    quality: "คุณภาพ",
    specis: "ชื่อสเปก",
    trackingNumber: "หมายเลขเอกสาร",
    description: "คำอธิบายปัญหาคุณภาพ",
    productionQuantity: "จำนวนผลิต/จำนวนตัวอย่าง",
    nonconformingCount: "จำนวน/อัตราของสินค้าที่ไม่ผ่าน",
    follower: "ผู้ติดตาม",
    responsibleDepartment: "แผนกรับผิดชอบ",
    responsiblePerson: "ผู้รับผิดชอบ",
    creator: "ผู้สร้าง",
    formFiller: "ผู้กรอกแบบฟอร์ม",
    rootCauseAnalysis: "การวิเคราะห์สาเหตุหลัก",
    rectificationMeasures: "มาตรการแก้ไข",
    completionTimeOfRectification: "เวลาสำเร็จการแก้ไข",
    validator: "ผู้ตรวจสอบ",
    verificationCompletionTime: "เวลาสิ้นสุดการตรวจสอบ",
    verificationResult: "ผลการตรวจสอบ",
    requestRectificationTime: "เวลาขอแก้ไข",
    actualRectificationTime: "เวลาที่แก้ไขจริง"
  },
  hostel: {
    code: "รหัสห้องพัก",
    facility: "สิ่งอำนวยความสะดวก",
    // 退租
    // 宿舍信息
  }
}



// WEBPACK FOOTER //
// ./src/lang/th.js